<template>
    <div>
        <span class="label">Vehicle Type</span>
         <div class="radio">
          <tl-radio name="vehicle" id="owned" label="Two Wheeler" value="two" v-model="vehicle" />
          <tl-radio name="vehicle" id="leased" label="Four wheeler" value="four" v-model="vehicle" />
        </div>
          <br><br>
        <div class="filters">
          <div>
            <span class="input-label">From</span>
            <date-picker @datevalue="(val)=>fromdate=val" :value="fromdate" />
          </div>
          <div>
            <span class="input-label">To</span>
            <date-picker @datevalue="(val)=>todate=val" :value="todate" />
          </div>
        </div>
        <div v-if="vehicle=='four'">
            <br><br>
           <span class="label">Car Engine Capacity</span>
           <div class="radio">
            <tl-radio name="capacity" id="less" label="Less than 1600 CC" value="less" v-model="capacity" />
            <tl-radio name="capacity" id="more" label="More than 1600 CC" value="more" v-model="capacity" />
           </div>
           <br><br>
           <tl-checkbox
             label="Is Driver provided?"
             :value="driver"
             @change="(val)=>driver=val"
            />
            <br>
            <div v-if="driver">
                 <div class="filters">
                    <div>
                        <span class="input-label">From</span>
                        <date-picker @datevalue="(val)=>driverfromdate=val" :value="driverfromdate" />
                    </div>
                    <div>
                        <span class="input-label">To</span>
                        <date-picker @datevalue="(val)=>drivertodate=val" :value="drivertodate" />
                    </div>
                    </div>
            </div>
        </div>
        <bottom-action-container >
          <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" @click="goBack" />
            <btn text="Save" :disabled="perk==''" type="primary" @click="save()" />
          </btn-grp>
         </template>
        </bottom-action-container>
        <pop-up-message v-if="showSuccessMsg" :message="`Car Perk added successfully.`" btnText="Ok" @back="okbtn()" />
    </div>
</template>

<script>
export default {
  data(){
    return{
      vehicle: 'two',
      fromdate:'',
      todate:'',
      driver:false,
      driverfromdate:'',
      drivertodate:'',
      capacity: 'less',
      showSuccessMsg: false
    }
  },
    methods: {
    goBack() { 
      this.$router.go(-1) 
     },
    save() {
      this.showSuccessMsg = true
    },
    okbtn() {
      this.showSuccessMsg = false
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.radio {
    display: flex;
    padding-top: 10px;
    div {
      padding-right: 20px;
    }
  }
.footer-width {
    width: 90%;
  }
</style>
